import { useEffect, useState } from "react";
import dataService from "../../../helpers/dataService";

// Demandes entreprise (MRP/AC/CYBER/RCPRO). `actif` = espace ENTREPRISE :
// hors de cet espace, aucun appel n'est émis — `GET quotations/mines` exige
// un rôle société et renvoie 403 (toast « Vous n'avez pas accès à cette
// société ») à un prospect sans fiche (PER-2416). Miroir de useAutoRequests.
const useForms = (actif = true) => {
  const [isLoading, setIsLoading] = useState(false);
  const [clients, setClients] = useState({});

  useEffect(() => {
    if (!actif) {
      setClients({});
      setIsLoading(false);
      return;
    }
    getForms();
  }, [actif]);

  const getForms = () => {
    setIsLoading(true);
    dataService.get(
      `quotations/mines`,
      setClients,
      (err) => {},
      () => setIsLoading(false)
    );
  };

  const hasMRP = clients.MRP?.length > 0;
  const hasAC = clients.AC?.length > 0;
  const hasCYBER = clients.CYBER?.length > 0;
  const hasRCPRO = clients.RCPRO?.length > 0;

  return {
    hasMRP,
    hasAC,
    hasCYBER,
    hasRCPRO,
    clients,
    isLoading,
  };
};

export default useForms;
